import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

const columns = [
  {
    title: "Products",
    links: [
      { label: "Girdercore", href: "https://girdercore.com", external: true },
      { label: "NightOwl", href: "https://nightowl.com", external: true },
      { label: "Zando", href: "https://zando.co", external: true },
      { label: "All products", to: "/#product" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { label: "Turnkey Payments", to: "/solutions/turnkey-payments" },
      { label: "Bank & Mobile Money", to: "/solutions/bank-mobile-money" },
      { label: "Security & Compliance", to: "/solutions/security-compliance" },
      { label: "Cloud Infrastructure", to: "/solutions/cloud-infrastructure" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Services", to: "/services" },
      { label: "Contact", to: "/contact" },
      { label: "Get Started", to: "/signup" },
      { label: "Sign In", to: "/login" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-white border-t border-stroke">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
        <div className="grid gap-12 text-center sm:grid-cols-3">
          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title} className="flex flex-col items-center">
              <h2 className="text-xs font-semibold uppercase tracking-wider text-ink">{col.title}</h2>
              <ul className="mt-4 space-y-3">
                {col.links.map((l, i) => (
                  <li key={`${l.label}-${i}`}>
                    {l.external ? (
                      <a
                        href={l.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-[0.95rem] text-slatey hover:text-brand transition-colors duration-200"
                      >
                        {l.label}
                        <ExternalLink className="h-3 w-3" aria-hidden="true" />
                      </a>
                    ) : (
                      <Link
                        to={l.to}
                        className="text-[0.95rem] text-slatey hover:text-brand transition-colors duration-200"
                      >
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-center gap-4 border-t border-stroke pt-8 sm:flex-row sm:justify-between">
          <p className="text-sm text-slatey">
            © {new Date().getFullYear()} Elikya Technology, Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/terms"
              data-testid="footer-terms"
              className="text-sm text-slatey transition-colors hover:text-brand"
            >
              Terms of Service
            </Link>
            <Link
              to="/privacy"
              data-testid="footer-privacy"
              className="text-sm text-slatey transition-colors hover:text-brand"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
